module.exports = __webpack_public_path__ + "static/media/startup.fafbb619.svg";